var Contact = {
	type_selected:"undefined",

	init:function(){
		
		if($(".rejoindre-mila").length){
			Contact.type_selected = "rejoindre";
		}

		$(".form-item[required] input, .form-item[required] textarea").on("input", function(){
			if($(this).val() != ""){
				$(this).parent().removeClass("required");
			}else{
				$(this).parent().addClass("required");
			}
		});

		$(".custom-radio input").change(function(){
			if($(this).is(":checked")){
				$(".custom-radio").removeClass("required");

				$(".accept-container").addClass("selected");

			}else{
				$(".custom-radio").addClass("required");
				$(".accept-container").removeClass("selected");
			}
		});

		$(".form-line.select .custom-select").find("select").change(function(){
			if($(this).val() == 'placeholder'){
				$(".form-line.select .select-container").addClass("required");
			}else{
				$(".form-line.select .select-container").removeClass("required");				
			}
		});

		$(".contact-selector .button").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
				

			Contact.switch_to_formulaire($(this).attr('data-type'));

		});



		$(".header-light .btn-prev").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}

			if((Contact.type_selected != "undefined") && ((Contact.type_selected != "rejoindre"))){
				Contact.switch_to_buttons();
			}else{
				window.history.back();
			}

		});

		$(".form-container *[type='submit']").on("click touchend", function(e){
			
			e.preventDefault();
			e.stopPropagation();
			
			if(e.type == "touchend"){
				$(this).off("click");
			}

			var _is_ok = Contact.check_formulaire();
			
			Debug.log("IS FORMULAIRE OK : " + _is_ok);
			
			if(_is_ok){
				$(this).closest(".form-container").submit();
			}
		});


		var hash = window.location.hash;
		
		if(hash != ""){
			Contact.switch_to_formulaire(hash.replace('#', ''))
		}


	},
	check_formulaire:function(){

		var _retour = true;
		
		Debug.log("CHECK FORMULAIRE : " + Contact.type_selected );

		var _current_form = $(".formulaire-container[data-type='" + Contact.type_selected + "']");


		_current_form.find(".form-item[required]").each(function(){

			if( $(this).find("input").val() == ""){
				$(this).addClass("required");
				_retour = false;
			}else{
				$(this).removeClass("required");
			}
		});

		if(_current_form.find(".form-line.select").length){
			if(_current_form.find(".form-item.select").find("select").val() == "placeholder"){
				_retour = false;	
				_current_form.find(".form-item.select").find(".select-container").addClass("required");
			}
		}

		if(_current_form.find(".form-line.textarea").css("display") != 'none'){
			if(_current_form.find(".form-line.textarea").find("textarea").val() == ''){
				_retour = false;
				_current_form.find(".form-line.textarea").find(".form-item").addClass("required");
			}else{
				_current_form.find(".form-line.textarea").find(".form-item").removeClass("required");
			}
		}

		if(_current_form.find(".custom-radio input").is(":checked") == false){
			_retour = false;
			_current_form.find(".custom-radio").addClass("required");
		}else{
			_current_form.find(".custom-radio").removeClass("required");
		}
		
		if(_current_form.find(".files-manager").length){
			if(_current_form.find(".files-manager input").val() == ''){
				_retour = false;
				_current_form.find(".files-manager").addClass("required");
			}else{				
				_current_form.find(".files-manager").removeClass("required");
			}
			
		}
		

		return _retour;
	},
	switch_to_formulaire:function(pValue){
		
		Contact.type_selected = pValue;

		$(".formulaire-container").each(function(){
			if($(this).attr("data-type") == pValue){
				$(this).addClass("visible");
			}else{
				$(this).removeClass("visible");
			}
		});

		if(pValue != "autre"){
			$(".illus-right").addClass("hidden");
			$(".img-1").addClass("hidden");
			$(".img-2").removeClass("hidden");
		}else{
			$(".img-1").removeClass("hidden");
			$(".img-2").addClass("hidden");
		}

		$(".contact-selector").addClass("hidden");
		$(".form-contact").addClass("visible");
	},
	switch_to_buttons:function(){
		Contact.type_selected = "undefined";


		$(".illus-right").removeClass("hidden");

		$(".img-1").removeClass("hidden");
		$(".img-2").addClass("hidden");

		$(".formulaire-container").removeClass("hidden");						
		$(".form-response").removeClass("displayed visible");

		$(".contact-selector").removeClass("hidden");
		$(".form-contact").removeClass("visible");

		$(".form-item[required]").removeClass("required");
		$(".form-item.select").find(".select-container").removeClass("required");
	}
}

$(window).load(function(){
	if($(".block-contact").length){
		Contact.init();
	}
});